var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSferum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4823 5.32538C16.9836 4.82703 16.3339 4.52762 15.587 4.41302C15.4723 3.6661 15.173 3.01643 14.6746 2.51768C11.3177 -0.839226 5.87457 -0.839226 2.51768 2.51768C-0.839226 5.87458 -0.839226 11.3177 2.51768 14.6746C3.01643 15.1733 3.6661 15.4723 4.41302 15.5873C4.52762 16.3343 4.82703 16.9839 5.32539 17.4823C8.68231 20.8392 14.1254 20.8392 17.4823 17.4823C20.8396 14.1254 20.8396 8.68268 17.4823 5.32538Z",
    fill: "url(#paint0_linear_15246_415224)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83921 7.84263C10.3451 5.33675 13.3844 4.07372 15.5824 4.41147C15.4678 3.66455 15.1684 3.01488 14.6701 2.51613C12.7041 0.550166 8.38878 1.6776 5.0319 5.03491C1.67499 8.39182 0.547146 12.7071 2.5131 14.673C3.01186 15.1718 3.66153 15.4708 4.40845 15.5858C4.0699 13.3878 5.33333 10.3485 7.83921 7.84263Z",
    fill: "url(#paint1_radial_15246_415224)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15246_415224",
    x1: 3.73109,
    y1: 15.4856,
    x2: 16.1348,
    y2: 4.63235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1277,
    stopColor: "#2006C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#4A0EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5106,
    stopColor: "#6B14C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6905,
    stopColor: "#8318C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8578,
    stopColor: "#911BC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#961CC7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_15246_415224",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2074 12.38) rotate(-128.972) scale(7.61211 11.2273)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B25CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4859,
    stopColor: "#2C93DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8379,
    stopColor: "#42DCE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BF9E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSferum);
export default __webpack_public_path__ + "static/media/sferum.d9418cbf.svg";
export { ForwardRef as ReactComponent };